import { Switch, Route } from "react-router-dom";
//import Alert from "./components/Alert";
import Overview from "./Overview";
import Events from "./Events";
import Sponsors from "./Sponsors";
import Venues from "./Venues";

import Admin from "./Admin";
import AdminCsv from "./Admin/Csv";
import AdminSnapshot from "./Admin/Snapshot";
import AdminInvoices from "./Admin/Invoices";
import AdminPayment from "./Admin/Payment/index.js";
import AdminVenues from "./Admin/Venues/index.js";
import AdminGuest from "./Admin/Guest/index.js";
import AdminAddons from "./Admin/Addons/index.js";
import AdminLinks from "./Admin/Links/index.js";

import AdminEmail from "./Admin/Email";
import AdminEmailEdit from "./Admin/EmailEdit";
import AdminEmailSend from "./Admin/EmailSend";

import AdminHotel from "./Admin/Hotel/index.js";
import AdminHotelEdit from "./Admin/Hotel/Edit.js";
import AdminHotelBulk from "./Admin/Hotel/Bulk.js";
import AdminHotelCsv from "./Admin/Hotel/Csv.js";
import AdminHotelUpload from "./Admin/Hotel/Upload.js";
import AdminHotelChanges from "./Admin/Hotel/Changes.js";

import HotelCsvSignin from "./Hotelcsv/Signin";
import HotelCsvChanges from "./Hotelcsv/Changes";
import HotelCsv from "./Hotelcsv";

import GuestSignin from "./Guest/Signin";
import GuestDecline from "./Guest/Decline";
import Guest from "./Guest";

import DashSignin from "./Dashboard/Signin";
import Dashboard from "./Dashboard";
import DashInvoice from "./Dashboard/Invoice";
import DashReceipt from "./Dashboard/Receipt";
import DashStatuses from "./Dashboard/Statuses";
import DashContact from "./Dashboard/Contact";
import DashUsers from "./Dashboard/Users";
import DashAsset from "./Dashboard/Asset";
import DashUpload from "./Dashboard/Upload";
import DashHotel from "./Dashboard/Hotel";
import DashHotelJW from "./Dashboard/Hotel/JW";
import DashHotelOther from "./Dashboard/Hotel/Other";
import DashHotelEdit from "./Dashboard/Hotel/Edit";
import DashHotelDelete from "./Dashboard/Hotel/Delete";
import DashHotelConfirmed from "./Dashboard/Hotel/Confirmed";
import DashInvite from "./Dashboard/Invite";
import DashGuest from "./Dashboard/Guest";
import DashPayment from "./Dashboard/Payment";

import RegSignin from "./Registration/Signin";
import Registration from "./Registration";
import RegBilling from "./Registration/Billing";
import RegPayment from "./Registration/Payment";
import RegReceipt from "./Registration/Receipt";
import RegAllocations from "./Registration/Allocations";
import RegLogo from "./Registration/Logo";
import RegQuestions from "./Registration/Questions";
import RegSubmitted from "./Registration/Submitted";

/* not used in 2026
import Tumi from "./Tumi";
import TumiSelected from "./Tumi/Selected";
import TumiSubmitted from "./Tumi/Submitted";
import TumiSignin from "./Tumi/Signin";
*/

import Survey from "./Survey";

const App = () => {
	return (
		<Switch>
			<Route exact path="/" component={Overview} />
			<Route exact path="/events" component={Events} />
			<Route exact path="/sponsors" component={Sponsors} />
			<Route exact path="/venues" component={Venues} />

			<Route exact path="/admin/hotel/changes" component={AdminHotelChanges} />
			<Route exact path="/admin/hotel/upload" component={AdminHotelUpload} />
			<Route exact path="/admin/hotel/csv" component={AdminHotelCsv} />
			<Route exact path="/admin/hotel/edit/:str" component={AdminHotelEdit} />
			<Route exact path="/admin/hotel/bulk/:id" component={AdminHotelBulk} />
			<Route exact path="/admin/hotel" component={AdminHotel} />

			<Route exact path="/admin/email/send" component={AdminEmailSend} />
			<Route exact path="/admin/email/edit" component={AdminEmailEdit} />
			<Route exact path="/admin/email" component={AdminEmail} />

			<Route exact path="/admin/links" component={AdminLinks} />
			<Route exact path="/admin/addons" component={AdminAddons} />
			<Route exact path="/admin/guest" component={AdminGuest} />
			<Route exact path="/admin/venues" component={AdminVenues} />
			<Route exact path="/admin/payment" component={AdminPayment} />
			<Route exact path="/admin/snapshot" component={AdminSnapshot} />
			<Route exact path="/admin/invoices" component={AdminInvoices} />
			<Route exact path="/admin/csv" component={AdminCsv} />
			<Route exact path="/admin" component={Admin} />

			<Route exact path="/hotelcsv/changes/:str" component={HotelCsvChanges} />
			<Route exact path="/hotelcsv/:str" component={HotelCsv} />
			<Route exact path="/hotelcsv" component={HotelCsvSignin} />

			<Route exact path="/guest/decline/:str" component={GuestDecline} />
			<Route exact path="/guest/:str" component={Guest} />
			<Route exact path="/guest" component={GuestSignin} />

			<Route exact path="/dashboard/payment/:str" component={DashPayment} />
			<Route exact path="/dashboard/guest/:str" component={DashGuest} />
			<Route exact path="/dashboard/asset" component={DashAsset} />
			<Route exact path="/dashboard/upload" component={DashUpload} />
			<Route
				exact
				path="/dashboard/hotel/edit/:str"
				component={DashHotelEdit}
			/>
			<Route
				exact
				path="/dashboard/hotel/delete/:str"
				component={DashHotelDelete}
			/>
			<Route
				exact
				path="/dashboard/hotel/confirmed/:str"
				component={DashHotelConfirmed}
			/>
			<Route exact path="/dashboard/hotel/jw" component={DashHotelJW} />
			<Route exact path="/dashboard/hotel/other" component={DashHotelOther} />
			<Route exact path="/dashboard/hotel" component={DashHotel} />
			<Route exact path="/dashboard/users" component={DashUsers} />
			<Route exact path="/dashboard/contact" component={DashContact} />
			<Route exact path="/dashboard/receipt" component={DashReceipt} />
			<Route exact path="/dashboard/invoice" component={DashInvoice} />
			<Route exact path="/dashboard/statuses" component={DashStatuses} />
			<Route exact path="/dashboard/statuses/:str" component={DashStatuses} />
			<Route exact path="/dashboard/invite" component={DashInvite} />
			<Route exact path="/dashboard/:str" component={Dashboard} />
			<Route exact path="/dashboard" component={DashSignin} />

			<Route exact path="/registration/submitted" component={RegSubmitted} />
			<Route exact path="/registration/questions" component={RegQuestions} />
			<Route exact path="/registration/logo" component={RegLogo} />
			<Route
				exact
				path="/registration/allocations"
				component={RegAllocations}
			/>
			<Route exact path="/registration/receipt" component={RegReceipt} />
			<Route exact path="/registration/payment" component={RegPayment} />
			<Route exact path="/registration/billing" component={RegBilling} />
			<Route exact path="/registration/:str" component={Registration} />
			<Route exact path="/registration" component={RegSignin} />

			{/*<Route exact path="/tumi/signin" component={TumiSignin} />
			<Route exact path="/tumi/submitted" component={TumiSubmitted} />
			<Route exact path="/tumi/selected" component={TumiSelected} />
			<Route exact path="/tumi/:str" component={Tumi} />
			<Route exact path="/tumi" component={Tumi} />*/}

			<Route exact path="/survey" component={Survey} />
		</Switch>
	);
};

export default App;

/*<Route exact path="/registration">
  <Alert
    data={{
      type: "error",
      text: "An error occurred, registration invite code required.",
    }}
  />
</Route>*/
